var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-image__wrapper"},[(_vm.clientLogo)?_c('img',{staticClass:"client-image",attrs:{"src":_vm.clientLogo,"alt":"Client logo"}}):_c('h4',[_vm._v(_vm._s(_vm.clientName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }